import { render, staticRenderFns } from "./UserAppResetPasswordDialog.vue?vue&type=template&id=17d63361"
import script from "./UserAppResetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./UserAppResetPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports